import { useState } from "react";
import { Beer } from "../../data/types";
import "./CustomDropDown.scss";

interface CustomDropdownProps {
  options: Beer[];
  selected: Beer | null;
  onChange: (beer: Beer) => void;
  number: number;
}

const CustomDropdown = ({
  options,
  selected,
  onChange,
  number,
}: CustomDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="custom-dropdown">
      <div
        className={
          isOpen
            ? "custom-dropdown__select custom-dropdown__select--selected"
            : "custom-dropdown__select"
        }
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected ? selected.name : "Select Beer " + number}
      </div>

      {isOpen && (
        <ul className="custom-dropdown__options">
          {options.map((beer) => (
            <li
              key={beer.name}
              onClick={() => {
                onChange(beer);
                setIsOpen(false);
              }}
            >
              {beer.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
